<div>
    <mat-card appearance="outlined">
        <div class="note-details-container">
            <mat-icon *ngIf="patientNote.isSuccess" class="status-icon" svgIcon="check-circle"></mat-icon>
            <mat-icon *ngIf="!patientNote.hasBeenSubmittedToSor && !patientNote.isSuccess" class="status-icon" svgIcon="test"></mat-icon>
            <mat-icon *ngIf="patientNote.hasBeenSubmittedToSor && !patientNote.isSuccess" class="status-icon" svgIcon="cross-circle"></mat-icon>
        <div class="note-patient-details-container">
            <div class="note">
                <app-read-more class="note-text t4" [text]="patientNote.note" [maxLength]="320"></app-read-more>
                <span ></span>
            </div>
            <div class="patient-details">
                <span class="t3 bold">{{ patientNote.username }} | {{ patientNote.createdDateTime | date: 'dd/MM/yyyy' }}</span>
            </div>
            <div class="row" *ngIf="patientNote.hasBeenSubmittedToSor && !patientNote.isSuccess">
                <div class="col">
                    <div class="alert alert-danger alert-dismissible fade show">{{ patientNote.error }}
                    </div>
                </div>
            </div>
        </div>
    </div>
    </mat-card>
</div>